import React, { useEffect, useState } from "react";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import { auth } from "../../../firebase-config";
import { findUserByUID } from "../../../service/findUsers/findUserByUID";
import ArLogo from "../../../components/CssComponents/ArLogo/ArLogo";
import LoginInput from "../../../components/FlowComponents/LoginInput/LoginInput";
import LoginOtpVerify from "../../../components/FlowComponents/LoginOtpVerify/LoginOtpVerify";
import styles from "../../../styles/Signin.module.css";
import backbutton from "./backbutton.png";

const Signin = () => {
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [showSign, setShowSign] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Ensure the recaptcha-container element exists
    const recaptchaContainer = document.getElementById("recaptcha-container");
    if (recaptchaContainer) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        recaptchaContainer,
        {
          size: "invisible",
          callback: (response) => {
            console.log("reCAPTCHA solved");
          },
        }
      );
    }

    // Cleanup on component unmount
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }
    };
  }, []);

  // receiving where is getting called
  // from child components
  const handleSignInClick = (phone) => {
    sendVerificationCode(phone);
    setShowSign(false);
  };

  const handleOtpVerify = (otpComing) => {
    verifyOtp(otpComing);
  };

  const sendVerificationCode = (phone) => {
    const appVerifier = window.recaptchaVerifier;
    signInWithPhoneNumber(auth, phone, appVerifier)
      .then((result) => {
        setConfirmationResult(result);
        notification.success({
          message: "OTP sent to your phone",
          placement: "topRight",
          duration: 3,
        });
      })
      .catch((error) => {
        notification.error({
          message: "Failed to send OTP",
          description: "Please try again.",
          placement: "topRight",
          duration: 3,
        });
      });
  };

  const verifyOtp = (otp) => {
    if (!confirmationResult) {
      notification.info({
        message: "OTP Request Needed",
        description: "First request the OTP",
        placement: "topRight",
        duration: 3,
      });
      return;
    }
    confirmationResult
      .confirm(otp)
      .then(async (result) => {
        const user = result.user;
        const userDetails = await findUserByUID(user.uid);
        if (!userDetails || userDetails.userTypes !== "club_admin") {
          notification.info({
            message: "User Details not found, unAuthorised acess",
            description: `Redirecting to home in 5 seconds`,
            placement: "topRight",
            duration: 5,
          });
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 5000);
        }
        notification.success({
          message: "Phone number & user verified",
          placement: "topRight",
          duration: 3,
        });
      })
      .catch((error) => {
        notification.error({
          message: "Verification Failed",
          description: `${error.message}`,
          placement: "topRight",
          duration: 3,
        });
      });
  };

  return (
    <div className={styles.signin}>
      <div className={styles.container}>
        {showSign ? (
          <></>
        ) : (
          <div onClick={() => setShowSign(true)} className={styles.icon}>
            <img
              className={styles.iconImage}
              src={backbutton}
              alt={"Back Button"}
            />
          </div>
        )}
        <div id="recaptcha-container"></div>
        <ArLogo />
        <div className={styles.heading}>ClubAdmin Login</div>
        {showSign ? (
          <LoginInput onSignInClick={handleSignInClick} />
        ) : (
          <LoginOtpVerify onOtpVerify={handleOtpVerify} />
        )}
      </div>
    </div>
  );
};

export default Signin;
